import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from './Icon.js';
// Variant → palette mapping. Tinted variants use the preset's `-500`
// shade with the `/10` opacity modifier so the background blends with
// whatever the surface beneath resolves to (works in both light and
// dark themes without a second source of truth). Foregrounds for the
// tinted variants resolve through the semantic `--fg-<variant>`
// tokens declared in `apps/admin/src/index.css` (and mirrored in the
// kit's `sketchpad.css`) — each is `light-dark()`-aware so the foreground
// brightens in dark mode to keep WCAG 2.2 AA over the composited tint.
// Brand uses the preset's flat brand shades (brand pills are
// brand-affirming UI; the background stays branded in both themes).
// Neutral references the semantic `--bg-sunken` / `--fg-secondary`
// tokens so the surface follows `data-theme`; the Tailwind
// arbitrary-value class form keeps every semantic binding grep-able
// from this file.
const PALETTE = {
    neutral: {
        variantClasses: 'bg-[color:var(--bg-sunken)] text-[color:var(--fg-secondary)]',
        dotClass: 'bg-neutral-400',
    },
    brand: {
        variantClasses: 'bg-brand-50 text-brand-700',
        dotClass: 'bg-brand-500',
    },
    success: {
        variantClasses: 'bg-success-500/10 text-[color:var(--fg-success-on-tint)]',
        dotClass: 'bg-success-500',
    },
    warning: {
        variantClasses: 'bg-warning-500/10 text-[color:var(--fg-warning-on-tint)]',
        dotClass: 'bg-warning-500',
    },
    danger: {
        variantClasses: 'bg-danger-500/10 text-[color:var(--fg-danger-on-tint)]',
        dotClass: 'bg-danger-500',
    },
    info: {
        variantClasses: 'bg-info-500/10 text-[color:var(--fg-info-on-tint)]',
        dotClass: 'bg-info-500',
    },
};
const BASE_CLASSES = 'inline-flex items-center gap-1.5 rounded-full font-semibold whitespace-nowrap';
const DOT_CLASSES = 'inline-block rounded-full shrink-0 w-1.5 h-1.5';
export function Badge({ variant = 'neutral', size = 'md', icon, children, }) {
    const palette = PALETTE[variant];
    const sizeClasses = size === 'sm'
        ? 'px-2 py-0.5 text-[11px]'
        : 'px-2.5 py-1 text-xs';
    return (_jsxs("span", { className: `${BASE_CLASSES} ${sizeClasses} ${palette.variantClasses}`, children: [_jsx("span", { "aria-hidden": "true", className: `${DOT_CLASSES} ${palette.dotClass}` }), icon !== undefined ? _jsx(Icon, { name: icon, size: 12 }) : null, children] }));
}
//# sourceMappingURL=Badge.js.map